const STATE_NAMESPACE = 'subscriptions';
export default STATE_NAMESPACE;
